module.exports = __webpack_public_path__ + "img/loong-small.1cf923d1.png";